// extracted by mini-css-extract-plugin
export default {"root":"fuYJV8","spinner":"q4fpr5","spinner-rotate":"sqiFbB","spinnerRotate":"sqiFbB","circle":"WRjDFM","spinner-dash":"gpxbMK","spinnerDash":"gpxbMK"};